<template>
  <EmbedPlayerShell :episode="episode" :episodes="episodes" />
</template>

<script>
import auth from 'auth'
import EmbedPlayerShell from 'components/reused-components/embed-player-shell/EmbedPlayerShell'
import config from 'conf'
import { event } from 'utils'

export default {
  components: {
    EmbedPlayerShell,
  },
  data() {
    return {
      episode: null,
      episodes: null,
    }
  },
  mounted() {
    this.initPlayer()
  },
  beforeDestroy() {
    event.$off('showEmbedPlayer', this.loadEpisodeAndShowPlayer)
  },
  methods: {
    initPlayer() {
      event.$on('showEmbedPlayer', this.loadEpisodeAndShowPlayer)
      event.$on('showEmbedArchivePlayer', this.loadPodcastAndShowPlayer)
    },
    loadPodcastAndShowPlayer(podcastId, accessKey) {
      this.loadPodcast(podcastId, accessKey)
    },
    loadEpisodeAndShowPlayer(episodeId, accessKey) {
      this.loadEpisode(episodeId, accessKey, false)
    },
    loadPodcast(podcastId, accessKey) {
      let url = `${config.url.episodesByPodcast}/${podcastId}`
      if (accessKey) {
        url += `?access_key=${accessKey}`
      }

      this.$http
        .get(url, {
          params: {},
          headers: auth.getAuthHeader(),
        })
        .then((response) => {
          this.episodes = response?.body.data
        })
    },
    loadEpisode(episodeId, accessKey) {
      let url = `${config.url.episodes}/${episodeId}`
      if (accessKey) {
        url += `?access_key=${accessKey}`
      }

      this.$http
        .get(url, {
          params: {},
          headers: auth.getAuthHeader(),
        })
        .then((response) => {
          this.episode = response?.body.data
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/embedplayer/EmbedPlayer.vue